import React, { Component } from 'react'
import { withRouter } from 'react-router'
import Icon from 'components/icon/icon'

import {
	openModal,
	updateTask,
	removeCommentsFromTask,
	addQuickTask
} from 'state/actions'

import { connect } from 'react-redux'
import { find, merge } from 'lodash'
import copy from 'fast-copy'

import { Link } from 'react-router-dom'

import {
	getCurrentUser,
} from 'state/selectors'

import {
	isMobile,
	getPrimaryColumnValue
} from 'utils'

class TaskName extends Component {
	state = {
		nameValue: this.props.task ? this.props.task.name : '',
		defaultValue: this.props.task ? this.props.task.name : ''
	}

	componentDidMount() {
		const {
			task,
			allComments,
			removeCommentsFromTask
		} = this.props

		if (task && task.comments) {
			const commentIds = merge(task.comments, task.commentIds)

			const commentsToRemove = []

			commentIds.forEach(commentId => {
				const commentObject = allComments[commentId]

				if (!commentObject) {
					commentsToRemove.push(commentId)
				}
			})

			removeCommentsFromTask(task, commentsToRemove)
		}
	}

	openTask = _ => {
		const {
			currentEditedTask,
			task,
			history,
			match
		} = this.props

		if (currentEditedTask !== task.id) {
			history.push(match.path + '/' + task.id)
		}
	}

	editTaskName = _ => {
		const {
			editTaskName,
			task,
		} = this.props

		editTaskName(task.id)

		this.setState({
			oldTaskName: task.name
		})

		setTimeout(_ => {
			if (this.taskNameRef) {
				this.taskNameRef.focus()
			}
		}, 1)
	}

	saveTaskName = _ => {
		if (this.taskNameRef.value) {
			let taskObject = copy(this.props.task)
			taskObject.name = this.taskNameRef.value

			this.setState({
				nameValue: taskObject.name
			})

			this.props.updateTask(taskObject)

			this.props.editTaskName(null)
		}
	}

	cancelEditingTaskName = _ => {
		this.props.editTaskName(null)

		this.setState({
			nameValue: this.state.defaultValue
		})
	}

	UNSAFE_componentWillUpdate(nextProps) {
		if (this.props.task.name != nextProps.task.name) {
			this.setState({
				nameValue: nextProps.task.name
			})
		}
	}

	restoreTask = _ => {
		this.props.openModal('restore', 'task', {
			data: this.props.task
		})
	}

	isTaskInUnopenedNotification = _ => {
		const {
			allNotifications,
			allComments,
			userData,
			task
		} = this.props

		const isTaskInUnopenedNotification = find(allNotifications, notification => {
			if (!notification.has_opened && notification.recipient_id === userData.id) {
				if (notification.notifyable_type == 'App\\Comment') {
					const commentObject = allComments && allComments[notification.notifyable_id];

					if (!commentObject) {
						return false
					}

					if (commentObject.task_id === task.id) {
						return true
					}
				}
			}
		})

		return isTaskInUnopenedNotification
	}

	handleChange = (value, key) => {
		this.setState({
			[key]: value
		})
	}

	getUrl = _ => {
		const {
			task,
			match,
			parentProject
		} = this.props

		let pathname = match.path

		if (parentProject) {
			const accountSlug = pathname.split('/')[1]

			return `/${accountSlug}/projects/${parentProject.slug}/tasks/${task.id}`
		}

		if (pathname.includes('/meetings')) {
			pathname = pathname.replace('/meetings', '/tasks')
		}

		pathname += '/' + task.id

		return pathname
	}

	openRecurringModal = _ => {
		const {
			openModal,
			task
		} = this.props

		openModal('recur', 'task', { task })
	}

	addQuickTask = _ => {
		const {
			addQuickTask,
			task
		} = this.props

		addQuickTask(task)
	}

	render() {
		const {
			currentProject,
			addTaskToTodos,
			allComments,
			areEntitiesRecoverable,
			currentEditedTask,
			deleteTask,
			isProjectEditable,
			canAddToToDo,
			task,
			userData,
			width,
			isPlanning,
			setSingleTaskVisible
		} = this.props

		const {
			nameValue
		} = this.state

		let hasUnseenComments = false

		let commentCount = task.commentIds ? task.commentIds.length : 0

		// Kinda hacky, but we can't easily fake-denormalise commentId array as it's in alwaysOverwrite
		if (task.comments && task.comments.length > commentCount) {
			commentCount = task.comments.length
		}

		let isBeingEdited = false

		if (task.id && currentEditedTask == task.id) {
			isBeingEdited = true
		}

		if (task.commentIds) {
			task.commentIds.sort()
			task.comments && task.comments.sort()

			let lastCommentId = null
			let lastComment = null

			if (task.commentIds.length) {
				lastCommentId = task.commentIds[(task.commentIds.length - 1)]
			}

			if (task.comments && task.comments.length && task.comments.length > task.commentIds.length) {
				let tempLastCommentId = task.comments[(task.comments.length - 1)]

				if (tempLastCommentId > lastCommentId) {
					lastCommentId = tempLastCommentId
				}
			}

			if (lastCommentId) {
				if (allComments) {
					lastComment = allComments[lastCommentId]
				}

				if (lastComment && lastComment.seen_by && lastComment.seen_by.indexOf(userData.id) === -1) {
					hasUnseenComments = true
				}
			}
		}

		if (task.versions) {
			commentCount += task.versions.length
		}

		let addToTodoMessage = 'Add to my to-do'

		const primaryStatusColumnId = getPrimaryColumnValue('status', task, currentProject)

		if (primaryStatusColumnId == 3) {
			addToTodoMessage = 'Already complete'
		} else if (!canAddToToDo) {
			addToTodoMessage = 'Already in to-do'
		}

		let className = 'task-name'

		if (isBeingEdited) {
			className += ' edited'
		}

		if (commentCount) {
			className += ' has-comments'
		}

		const inputProps = {
			disabled: !!(!task.id || currentEditedTask != task.id),
			onKeyPress: e => {
				(e.key === 'Enter' ? this.saveTaskName() : null)
			},
			onChange: e => {
				this.handleChange(e.target.value, 'nameValue')
			},
			value: nameValue ? nameValue : '',
		}

		if (isMobile()) {
			inputProps.maxRows = 4
			inputProps.inputRef = ref => {
				this.taskNameRef = ref
			}
		} else {
			inputProps.ref = ref => {
				this.taskNameRef = ref
			}
		}

		const isInUnopenedNotification = this.isTaskInUnopenedNotification()

		return (
			<div className={className} style={{ width }}>
				{isMobile() ?
					<span disabled className="task-name-span">{nameValue}</span>
					:
					<input type="text" {...inputProps} />
				}
				{ currentEditedTask !== task.id &&
					<Link
						to={this.getUrl()}
						onClick={e => {
							if (currentEditedTask === task.id || task.isRecurredDuplicate) {
								e.preventDefault()
							} else if (isPlanning) {
								e.preventDefault()
								setSingleTaskVisible()
							}
						}}
						className={(task && task.isRecurredDuplicate) ? 'tooltip-trigger' : ''}
					>
						{(task.isRecurredDuplicate) &&
							<div className="tooltip">
								This is a future recurrence, and can't be edited yet.
							</div>
						}
					</Link>
				}
				{ (commentCount || task.is_recurring || task.is_quick_task) ?
					<i className={'task-mini-meta'}>
						{commentCount ?
							<span className={(hasUnseenComments || isInUnopenedNotification) ? 'unread comments' : ' comments'}>
								{commentCount}
								<Icon name="fe-mail" />
								{isInUnopenedNotification ?
									<i className="has-unopened-notifications" />
									: null}
							</span>
							: null}
						{task.is_recurring ?
							<span className="recurring">
								<Icon name="fe-refresh-cw" />
							</span>
							: null
						}
						{(task.is_quick_task && window.hasPlanning) &&
							<span className={'quick-task'}>
								<Icon name={'bolt'} />
							</span>
						}
					</i>
					: null
				}
				{ isBeingEdited ?
					<ul>
						<li>
							<Icon onClick={this.saveTaskName} name="check" />
						</li>
						<li>
							<Icon onClick={this.cancelEditingTaskName} name="ban" />
						</li>
					</ul>
					:
					<ul>
						{(isProjectEditable || areEntitiesRecoverable) &&
							<div>
								{task.deleted_at ?
									<div>
										<li className="tooltip-trigger">
											<Icon onClick={this.restoreTask} name="reply" />
											<div className="tooltip">
												Restore task
											</div>
										</li>
										<li className="tooltip-trigger">
											<Icon onClick={deleteTask} name="fe-trash-2" />
											<div className="tooltip">
												Delete task
										</div>
										</li>
									</div>
									:
									<div>
										{(window.hasPlanning && window.isTkb) ?
											<li className={`tooltip-trigger ${task.is_quick_task ? 'highlighted' : ''}`}>
												<Icon
													onClick={this.addQuickTask}
													name={'bolt'}
												/>
												<div className={'tooltip'}>
													{task.is_quick_task ? `Remove from resourcing` : `Add to resourcing`}
												</div>
											</li>
											: null}
										<li className={'tooltip-trigger'}>
											<Icon
												onClick={this.openRecurringModal}
												name="fe-refresh-cw"
											/>
											<div className="tooltip">
												{task.is_recurring ? 'Edit recurrence' : 'Make recurring'}
											</div>
										</li>
										<li className={canAddToToDo ? 'tooltip-trigger' : 'tooltip-trigger disabled'}>
											<Icon onClick={_ => { canAddToToDo ? addTaskToTodos() : null }} name="fe-check-square" />
											<div className="tooltip">
												{addToTodoMessage}
											</div>
										</li>
										<li className="tooltip-trigger">
											<Icon onClick={this.editTaskName} name="fe-edit-2" />
											<div className="tooltip">
												Edit name
											</div>
										</li>
										<li className="tooltip-trigger">
											<Icon onClick={deleteTask} name="fe-trash-2" />
											<div className="tooltip">
												Archive task
											</div>
										</li>
									</div>
								}
							</div>
						}
					</ul>
				}
			</div>
		)
	}
}

const mapStateToProps = state => {
	return {
		userData: getCurrentUser(state),
		allFiles: state.account.entities.files,
		allVersions: state.account.entities.versions,
		allNotifications: state.account.entities.notifications,
		allComments: state.account.entities.comments,
	}
}

export default withRouter(connect(mapStateToProps, {
	openModal,
	updateTask,
	removeCommentsFromTask,
	addQuickTask
})(TaskName))
